exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".detailsCard-5bec0c6d{width:100%;display:flex;flex-direction:column}.top-1c925094{position:relative;height:270px}.cover-9fb2cae2{height:100%;width:100%;object-fit:cover;background-position:center center;background-repeat:no-repeat;background-size:cover}.icon-891895ce{position:absolute;bottom:20px;left:20px}.bottom-aaa91301{margin:20px;display:flex;flex-direction:column}.infoRow-511535d0{margin:5px 0px}.infoRow-511535d0 span{color:#757575;margin-right:14px}.description-b4a80dcc{border-top:1px solid #E0E0E0;margin-top:10px;padding-top:15px;white-space:pre-line}.description-b4a80dcc.empty-9db04502{color:#757575}.targetRow-dc10dd01{margin:5px 0px;display:flex}.targetRow-dc10dd01 span{margin-right:14px;color:#757575}.targetRow-dc10dd01 .text-cce8fa2c{display:flex;flex-direction:column}.targetRow-dc10dd01 .text-cce8fa2c span{color:#757575}.settingsLink-b4adbd03{font-weight:500;font-size:14px;line-height:16px}\n", ""]);

// Exports
exports.locals = {
	"detailsCard": "detailsCard-5bec0c6d",
	"top": "top-1c925094",
	"cover": "cover-9fb2cae2",
	"icon": "icon-891895ce",
	"bottom": "bottom-aaa91301",
	"infoRow": "infoRow-511535d0",
	"description": "description-b4a80dcc",
	"empty": "empty-9db04502",
	"targetRow": "targetRow-dc10dd01",
	"text": "text-cce8fa2c",
	"settingsLink": "settingsLink-b4adbd03"
};